import { ConfigProvider, Table, theme } from 'antd'
import { ColumnType } from 'antd/es/table'
import { FC, memo } from 'react'
import Material from '../../../../types/api/material'

const onHeaderCell = () => ({ style: { backgroundColor: '#bae7ff' } })

const initialColumn: ColumnType = {
    title: 'Ширина, мм',
    width: 120,
    render(v, r, i) {
        const rowNames: { [i: number]: string } = {
            0: 'На складе, км',
            1: 'Забронировано, км',
            2: 'Свободно, км',
        }
        return rowNames[i]
    },
    onHeaderCell,
}

interface MaterialsTableProps {
    materials?: Material[]
}

const MaterialsTable: FC<MaterialsTableProps> = ({ materials = [] }) => {
    const columns = [initialColumn]
    const dataSource = [{ id: 0 }, { id: 2 }, { id: 3 }]
    const sortedMaterials = [...materials].sort((a, b) => a.width - b.width)

    sortedMaterials.forEach(material => {
        columns.push({
            key: material.documentId,
            dataIndex: material.documentId,
            title: material.width,
            width: 50,
            render(v, r, i) {
                const stockLengthSummary =
                    material.stocks?.reduce((acc, cur) => acc + cur.amount, 0) || 0
                const stockReservedLengthSummary =
                    material.stocks?.reduce(
                        (acc, cur) =>
                            acc +
                            (cur.stock_reserves?.reduce((acc, cur) => acc + (cur.amount || 0), 0) || 0),
                        0
                    ) || 0

                const rowValues: { [i: number]: number } = {
                    0: stockLengthSummary,
                    1: stockReservedLengthSummary,
                    2: stockLengthSummary - stockReservedLengthSummary,
                }

                return rowValues[i]
            },
            onHeaderCell,
        })
    })

    return (
        <ConfigProvider theme={{ algorithm: theme.compactAlgorithm }}>
            <Table
                size={'small'}
                style={{ width: 'fit-content' }}
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                rowKey={x => x.id}
                showHeader
            />
        </ConfigProvider>
    )
}

export default memo(MaterialsTable)
